import { useState } from "react";
import Box from "@mui/material/Box";

import { useI18n } from "@/i18n/I18nProvider";

const WHATSAPP_CHAT_URL = "https://wa.me/20216177";

const WHATSAPP_ICON =
  "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/whatsapp.webp";

/*
 * The floating "chat with us" button, pinned to the reading edge of the
 * viewport. Hovering it reveals a localized call-to-action image beside it.
 */
export default function WhatsAppWidget() {
  const { t, locale } = useI18n();
  const [isLabelVisible, setIsLabelVisible] = useState(false);

  const edge = locale === "ar" ? "right" : "left";

  return (
    <Box>
      <Box
        component="img"
        src={t.general.popup}
        alt="whatsapp text"
        loading="lazy"
        sx={{
          zIndex: 999,
          height: { xs: "60px", md: "100px", lg: "120px" },
          width: { xs: "185px", md: "300px", lg: "370px" },
          position: "fixed",
          bottom: { xs: "50px", md: "15px", lg: "5px" },
          transition: "1s",
          opacity: isLabelVisible ? 1 : 0,
          display: isLabelVisible ? "block" : "none",
          [edge]: { xs: "70px", md: "90px" },
        }}
      />

      <Box
        component="a"
        href={WHATSAPP_CHAT_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with us on WhatsApp"
        onMouseEnter={() => setIsLabelVisible(true)}
        onMouseLeave={() => setIsLabelVisible(false)}
        sx={{
          zIndex: 999,
          position: "fixed",
          bottom: "65px",
          [edge]: { xs: "25px", lg: "35px" },
        }}
      >
        <Box
          component="img"
          src={WHATSAPP_ICON}
          alt="whatsapp chat"
          loading="lazy"
          sx={{
            height: { xs: "40px", md: "55px" },
            width: { xs: "40px", md: "55px" },
          }}
        />
      </Box>
    </Box>
  );
}
